import { render, staticRenderFns } from "./assignments-quality.vue?vue&type=template&id=8f77038e&scoped=true&"
import script from "./assignments-quality.vue?vue&type=script&lang=js&"
export * from "./assignments-quality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f77038e",
  null
  
)

export default component.exports